import { render } from "./SelectModelTry.vue?vue&type=template&id=50f20a19&scoped=true"
import script from "./SelectModelTry.vue?vue&type=script&lang=js"
export * from "./SelectModelTry.vue?vue&type=script&lang=js"

import "./SelectModelTry.vue?vue&type=style&index=0&id=50f20a19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f20a19"]])

export default __exports__